import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon, Avatar } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { get, reply, resolve, remove } from "../../api/Review"

/* Widgets */
import { toast, confirm } from "../common"
import Stars from "./Stars"

/* Shared */
import { RATE_WORDS, COMPLAINT_STATUSES, rateAccentOf, reasonOf, photoOf, authorOf, ratingOf } from "./shared"
import { BOOKING_STATUSES, channelOf, ago, initialsOf, avatarColorOf, digitsOf } from "../user/shared"
import { organizationIcon } from "../organization/shared"
import { plural } from "../category/shared"
import { money } from "../service/shared"

/* Constants */
import { env } from "../../constants"

/* Moment */
import moment from "moment"

Modal.setAppElement("#root")


/* The roles of the team in the words of the points */
const ROLES = {
    owner: "Владелец",
    admin: "Администратор",
    specialist: "Специалист"
}


/* Widget Review Modal — the whole review: the words and the photos, the visit behind it, the point,
   the master and the client around it, the answer of the point and the complaints about it.
   It is opened by the reference: this._review.current.open(item) */
class ReviewModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            status: "loading",
            data: null,

            /* The line of the list — the top of the card is drawn while the rest loads */
            item: null,

            /* The answer of the point */
            replying: false,
            replyText: "",

            /* The answer of the moderator to a complaint */
            answers: {},

            /* The photo opened over the card */
            photo: -1,

            waiting: false
        }
    }

    open = item => {
        this.setState({ visible: true, item, status: "loading", data: null, replying: false, replyText: "", answers: {}, photo: -1, waiting: false }, () => this.load())
    }

    close = () => {

        if (this.state.waiting) {
            return
        }

        this.setState({ visible: false })
    }

    /* The form saved the review — the open card reads it again */
    reload = () => {
        if (this.state.visible) {
            this.load()
        }
    }

    load = () => {

        const { item } = this.state

        get({ id: item.id }).then(response => {
            if (response && response.status === 200) {
                this.setState({ status: "ok", data: response.data })
            }
            else if (response && response.status === 404) {
                this.setState({ status: "missing" })
            }
            else {
                this.setState({ status: "error" })
            }
        }).catch(() => this.setState({ status: "error" }))
    }

    /* Something changed — the card and the list read it again */
    changed = () => {

        const { onChanged } = this.props

        this.load()
        onChanged()
    }

    copy = text => {

        if (!navigator.clipboard) {
            return
        }

        navigator.clipboard.writeText(text).then(() => toast.success("Скопировано")).catch(() => { })
    }

    /* Save the answer of the point, an empty text takes it away */
    saveReply = text => {

        /* Fields */
        const { data, waiting } = this.state

        if (waiting) {
            return
        }

        this.setState({ waiting: true })

        reply({ id: data.review.id, reply: text }).then(response => {

            this.setState({ waiting: false })

            if (response && response.status === 200) {
                toast.success(text.trim().length > 0 ? "Ответ сохранён" : "Ответ удалён")
                this.setState({ replying: false, replyText: "" })
                this.changed()
            }
            else {
                toast.error("Что-то пошло не так! Попробуйте позднее")
            }
        }).catch(() => {
            this.setState({ waiting: false })
            toast.error("Что-то пошло не так! Попробуйте позднее")
        })
    }

    removeReply = () => {
        confirm({
            title: "Удалить ответ точки?",
            text: "Клиент больше не увидит его под своим отзывом",
            confirmText: "Удалить",
            cancelText: "Нет",
            danger: true
        }).then(confirmed => confirmed && this.saveReply(""))
    }

    /* The decision on a complaint: 1 — the review leaves the platform, 2 — it stays */
    decide = (complaint, decision) => {

        /* Fields */
        const { answers, waiting } = this.state
        const { onChanged } = this.props

        if (waiting) {
            return
        }

        const send = () => {

            this.setState({ waiting: complaint.id })

            resolve({ id: complaint.id, status: decision, answer: answers[complaint.id] ? answers[complaint.id] : "" }).then(response => {

                this.setState({ waiting: false })

                if (response && response.status === 200) {

                    if (response.data.removed) {
                        toast.success("Жалоба принята, отзыв удалён")
                        this.setState({ visible: false })
                        onChanged()
                        return
                    }

                    toast.success("Жалоба отклонена, отзыв остался")
                    this.changed()
                }
                else if (response && response.status === 409) {
                    toast.error("По этой жалобе уже приняли решение")
                    this.changed()
                }
                else {
                    toast.error("Что-то пошло не так! Попробуйте позднее")
                }
            }).catch(() => {
                this.setState({ waiting: false })
                toast.error("Что-то пошло не так! Попробуйте позднее")
            })
        }

        if (decision === 2) {
            send()
            return
        }

        confirm({
            title: "Принять жалобу?",
            text: "Отзыв и его фото удалятся с платформы, рейтинг точки пересчитается. Вернуть отзыв будет нельзя",
            confirmText: "Принять и удалить",
            cancelText: "Нет",
            danger: true
        }).then(confirmed => confirmed && send())
    }

    /* Remove the review by hand */
    remove = () => {

        /* Fields */
        const { data } = this.state
        const { onChanged } = this.props

        confirm({
            title: "Удалить отзыв?",
            text: "Отзыв и его фото удалятся навсегда, рейтинг точки и мастера пересчитается",
            confirmText: "Да, удалить",
            cancelText: "Нет",
            danger: true
        }).then(confirmed => {

            if (!confirmed) {
                return
            }

            remove({ id: data.review.id }).then(response => {
                if (response && response.status === 200) {
                    toast.success("Отзыв удалён")
                    this.setState({ visible: false })
                    onChanged()
                }
                else {
                    toast.error("Что-то пошло не так! Попробуйте позднее")
                }
            }).catch(() => toast.error("Что-то пошло не так! Попробуйте позднее"))
        })
    }

    /* The top of the card — the rate as big as the client meant it */
    _hero = () => {

        /* Fields */
        const { item, data } = this.state

        const review = data ? data.review : item
        const accent = rateAccentOf(review.rate)
        const author = authorOf(review)
        const avatar = review.userImage ? `${env.mediapoint}users/${review.userImage}` : null

        let source = { text: "Отзыв без записи", icon: "review", accent: "blue" }

        if (!review.userID) {
            source = { text: "Добавлен вручную", icon: "edit", accent: "grey" }
        }
        else if (review.bookingID) {
            source = { text: "После визита", icon: "booking", accent: "green" }
        }

        return (
            <div className={`review-hero ${accent}`}>

                <div className="review-hero-rate">
                    <b>{review.rate}</b>
                    <Stars value={review.rate} size={17} className="light" />
                    <span>{RATE_WORDS[review.rate]}</span>
                </div>

                <div className="review-hero-text">

                    <div className="review-hero-author" style={{ "--avatar": avatarColorOf(review.userID ? review.userID : review.id) }}>
                        <Avatar className="review-hero-avatar" src={avatar} alt={author}>
                            {author ? <span>{initialsOf(author)}</span> : <Icon name="user" size={20} width={2} />}
                        </Avatar>
                        <div>
                            <b>{author ? author : "Без имени"}</b>
                            <span>{moment(review.createdAt).format("D MMMM YYYY, HH:mm")} · {ago(review.createdAt)}</span>
                        </div>
                    </div>

                    <div className="user-hero-badges">
                        <div className={`user-badge ${source.accent}`}><Icon name={source.icon} size={12} width={2.2} />{source.text}</div>
                        {review.reply && <div className="user-badge violet"><Icon name="support" size={12} width={2.2} />Есть ответ точки</div>}
                        {review.userID && review.userActive === 0 && <div className="user-badge orange"><i />Аккаунт клиента отключён</div>}
                    </div>

                </div>

            </div>
        )
    }

    /* The complaints waiting for a decision stand first — that is the work of the card */
    _complaints = () => {

        /* Fields */
        const { data, answers, waiting } = this.state

        const complaints = data.complaints

        if (complaints.length === 0) {
            return null
        }

        return (
            <div className="user-section">

                <div className="user-section-title">
                    Жалобы точки
                    <span>{complaints.length} {plural(complaints.length, "жалоба", "жалобы", "жалоб")}</span>
                </div>

                <div className="review-complaints">
                    {complaints.map(complaint => {

                        const reason = reasonOf(complaint.reason)
                        const state = COMPLAINT_STATUSES[complaint.status] ? COMPLAINT_STATUSES[complaint.status] : COMPLAINT_STATUSES[0]
                        const pending = complaint.status === 0

                        return (
                            <div key={`${complaint.id}`} className={`review-complaint ${pending ? "pending" : ""}`}>

                                <div className="review-complaint-head">
                                    <div className="review-complaint-icon"><Icon name="alert" size={17} width={2} /></div>
                                    <div className="review-complaint-title">
                                        <b>{reason.text}</b>
                                        <span>{reason.hint}</span>
                                    </div>
                                    <div className={`user-badge ${state.accent}`}>{state.short}</div>
                                </div>

                                {complaint.comment && <div className="review-complaint-comment">«{complaint.comment}»</div>}

                                <div className="review-complaint-meta">
                                    <span><Icon name="user" size={12} width={2.2} />{complaint.member ? complaint.member : "Сотрудник ушёл из точки"}{complaint.role && ROLES[complaint.role] ? ` · ${ROLES[complaint.role]}` : ""}</span>
                                    {complaint.memberPhone && <span onClick={() => this.copy(complaint.memberPhone)} className="link">{complaint.memberPhone}</span>}
                                    <span>{moment(complaint.createdAt).format("D MMM YYYY, HH:mm")}</span>
                                </div>

                                {!pending && complaint.answer &&
                                    <div className="review-complaint-answer"><b>Ответ модератора:</b> {complaint.answer}</div>
                                }

                                {pending &&
                                    <div className="review-complaint-decision">
                                        <textarea
                                            maxLength={2000}
                                            placeholder="Ответ точке — необязательно"
                                            value={answers[complaint.id] ? answers[complaint.id] : ""}
                                            onChange={event => this.setState({ answers: { ...answers, [complaint.id]: event.target.value } })}
                                        />
                                        <div className="review-complaint-buttons">
                                            <div onClick={() => this.decide(complaint, 2)} className={`groups-modal-remove-button light ${waiting ? "disabled" : ""}`}>
                                                {waiting === complaint.id ? <LoadingOutlined /> : "Отклонить — отзыв остаётся"}
                                            </div>
                                            <div onClick={() => this.decide(complaint, 1)} className={`groups-modal-remove-button danger ${waiting ? "disabled" : ""}`}>
                                                Принять и удалить отзыв
                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>
                        )
                    })}
                </div>

            </div>
        )
    }

    /* The words and the photos of the client */
    _text = () => {

        /* Fields */
        const { data } = this.state

        const review = data.review
        const images = data.images

        return (
            <div className="user-section">

                <div className="user-section-title">Отзыв</div>

                {review.comment && `${review.comment}`.trim().length > 0
                    ? <blockquote className="review-quote">{review.comment}</blockquote>
                    : <div className="user-empty">Клиент поставил только оценку, без текста</div>
                }

                {images.length > 0 &&
                    <div className="review-gallery">
                        {images.map((image, index) =>
                            <div key={`${image.id}`} onClick={() => this.setState({ photo: index })} className="review-gallery-item">
                                <img src={photoOf(image.image)} alt="Фото отзыва" />
                            </div>
                        )}
                    </div>
                }

            </div>
        )
    }

    /* The answer of the point under the review */
    _reply = () => {

        /* Fields */
        const { data, replying, replyText, waiting } = this.state

        const review = data.review

        if (replying) {
            return (
                <div className="user-section">
                    <div className="user-section-title">Ответ точки</div>
                    <div className="review-reply-form">
                        <textarea autoFocus maxLength={2000} placeholder="Клиент увидит этот текст под своим отзывом как ответ точки" value={replyText} onChange={event => this.setState({ replyText: event.target.value })} />
                        <div className="user-actions-buttons">
                            <div onClick={() => this.setState({ replying: false, replyText: "" })} className="groups-modal-remove-button light">Отмена</div>
                            <div onClick={() => replyText.trim().length > 0 && this.saveReply(replyText)} className={`groups-modal-remove-button primary ${waiting || replyText.trim().length === 0 ? "disabled" : ""}`}>
                                {waiting ? <LoadingOutlined /> : "Сохранить ответ"}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        if (!review.reply || `${review.reply}`.trim().length === 0) {
            return (
                <div className="user-section">
                    <div className="user-section-title">Ответ точки</div>
                    <div onClick={() => this.setState({ replying: true, replyText: "" })} className="review-reply-empty">
                        <Icon name="support" size={18} width={2} />
                        <div>
                            <b>Точка ещё не ответила</b>
                            <span>Можно ответить от её имени — например, для отзыва, перенесённого из 2ГИС вместе с ответом</span>
                        </div>
                        <em>Ответить</em>
                    </div>
                </div>
            )
        }

        return (
            <div className="user-section">
                <div className="user-section-title">
                    Ответ точки
                    <span>{review.repliedAt ? moment(review.repliedAt).format("D MMM YYYY, HH:mm") : ""}</span>
                </div>
                <div className="review-reply">
                    <div className="review-reply-author">
                        <Icon name="organization" size={13} width={2.2} />
                        {review.replier ? review.replier : "От имени точки"}
                    </div>
                    <p>{review.reply}</p>
                    <div className="review-reply-actions">
                        <div onClick={() => this.setState({ replying: true, replyText: review.reply })}><Icon name="edit" size={13} width={2.2} />Изменить</div>
                        <div onClick={this.removeReply} className="danger"><Icon name="trash" size={13} width={2.2} />Удалить</div>
                    </div>
                </div>
            </div>
        )
    }

    /* Who stands around the review — the point, the master and the client */
    _context = () => {

        /* Fields */
        const { data } = this.state
        const { onClient, onOrganization } = this.props

        const review = data.review
        const organization = data.organization
        const spread = [
            { rate: 5, count: organization.five },
            { rate: 4, count: organization.four },
            { rate: 3, count: organization.three },
            { rate: 2, count: organization.two },
            { rate: 1, count: organization.one }
        ]

        /* How much this one review moves the rating of the point */
        const impact = organization.reviews > 1 ? organization.average - organization.withoutThis : 0

        return (
            <div className="user-section">

                <div className="user-section-title">Кто вокруг отзыва</div>

                <div className="review-context">

                    <div className="review-context-card">

                        <div className="review-context-head">
                            <Avatar className="review-context-avatar square" src={review.organizationImage ? `${env.mediapoint}organizations/${review.organizationImage}` : null} alt={review.organization}>
                                {organizationIcon()}
                            </Avatar>
                            <div>
                                <span>Точка</span>
                                <b>{review.organization ? review.organization : "Точка удалена"}</b>
                            </div>
                        </div>

                        <div className="review-context-rating">
                            <b>★ {ratingOf(organization.average)}</b>
                            <span>{organization.reviews} {plural(organization.reviews, "отзыв", "отзыва", "отзывов")}</span>
                        </div>

                        <div className="review-context-spread">
                            {spread.map(row =>
                                <i key={`${row.rate}`} className={`${rateAccentOf(row.rate)} ${parseInt(review.rate) === row.rate ? "current" : ""}`} style={{ flex: Math.max(row.count, 0.0001) }} title={`${row.rate} ★ — ${row.count}`} />
                            )}
                        </div>

                        <div className="review-context-facts">
                            {Math.abs(impact) >= 0.01 &&
                                <div className={impact > 0 ? "up" : "down"}>
                                    Этот отзыв {impact > 0 ? "поднимает" : "опускает"} рейтинг на {Math.abs(impact).toFixed(2).replace(".", ",")}
                                </div>
                            }
                            {organization.unanswered > 0 && <div>Без ответа: {organization.unanswered}</div>}
                        </div>

                        {review.organizationID && onOrganization &&
                            <div onClick={() => onOrganization({ id: review.organizationID, name: review.organization, image: review.organizationImage })} className="review-context-link">
                                Все отзывы точки <Icon name="right" size={13} width={2.4} />
                            </div>
                        }

                    </div>

                    <div className="review-context-card">

                        <div className="review-context-head">
                            <Avatar className="review-context-avatar" src={review.memberImage ? `${env.mediapoint}members/${review.memberImage}` : null} alt={review.member}>
                                <Icon name="user" size={18} width={2} />
                            </Avatar>
                            <div>
                                <span>Мастер</span>
                                <b>{review.member ? review.member : "Не указан"}</b>
                            </div>
                        </div>

                        {data.member
                            ? <div className="review-context-rating">
                                <b>★ {ratingOf(data.member.average)}</b>
                                <span>{data.member.reviews} {plural(data.member.reviews, "отзыв", "отзыва", "отзывов")} о мастере</span>
                            </div>
                            : <div className="review-context-muted">Отзыв о точке целиком</div>
                        }

                        {review.memberPhone && <div onClick={() => this.copy(review.memberPhone)} className="review-context-phone">{review.memberPhone}</div>}

                    </div>

                    <div className="review-context-card">

                        <div className="review-context-head" style={{ "--avatar": avatarColorOf(review.userID ? review.userID : review.id) }}>
                            <Avatar className="review-context-avatar client" src={review.userImage ? `${env.mediapoint}users/${review.userImage}` : null} alt={authorOf(review)}>
                                <Icon name="user" size={18} width={2} />
                            </Avatar>
                            <div>
                                <span>Клиент</span>
                                <b>{authorOf(review) ? authorOf(review) : "Без имени"}</b>
                            </div>
                        </div>

                        {data.client
                            ? <>
                                <div className="review-context-rating">
                                    <b>{data.client.here}</b>
                                    <span>{plural(data.client.here, "запись", "записи", "записей")} в этой точке, состоялось {data.client.completedHere}</span>
                                </div>
                                <div className="review-context-facts">
                                    <div>Всего записей: {data.client.bookings}</div>
                                    <div>Отзывов: {data.client.reviews}, обычно ставит ★ {ratingOf(data.client.average)}</div>
                                </div>
                                {review.userPhone && digitsOf(review.userPhone).length >= 10 &&
                                    <div onClick={() => this.copy(review.userPhone)} className="review-context-phone">{review.userPhone}</div>
                                }
                                <div onClick={() => onClient(review)} className="review-context-link">
                                    Карточка клиента <Icon name="right" size={13} width={2.4} />
                                </div>
                            </>
                            : <div className="review-context-muted">Аккаунта нет — отзыв добавлен вручную, например из 2ГИС</div>
                        }

                    </div>

                </div>

            </div>
        )
    }

    /* The visit the review was written after */
    _booking = () => {

        /* Fields */
        const { data } = this.state

        const booking = data.booking

        if (!booking) {
            return null
        }

        const state = BOOKING_STATUSES[booking.status] ? BOOKING_STATUSES[booking.status] : BOOKING_STATUSES[0]
        const channel = channelOf(booking.channel)
        const date = moment(booking.reservedTime)
        const after = moment(data.review.createdAt).diff(date, "days")

        return (
            <div className="user-section">

                <div className="user-section-title">
                    Визит
                    <span>{after > 0 ? `отзыв через ${after} ${plural(after, "день", "дня", "дней")} после визита` : "отзыв в день визита"}</span>
                </div>

                <div className={`user-booking ${state.accent}`}>

                    <div className="user-booking-date">
                        <b>{date.format("D")}</b>
                        <span>{date.format("MMM YY")}</span>
                    </div>

                    <div className="user-booking-body">
                        <div className="user-booking-title">
                            {booking.number ? `Запись №${booking.number}` : "Запись"}
                            <div className={`user-booking-status ${state.accent}`}>{state.text}</div>
                        </div>
                        <div className="user-booking-services">{booking.services ? booking.services : "Услуга не указана"}</div>
                        <div className="user-booking-meta">
                            <span>{date.format("HH:mm")}</span>
                            {booking.member && <span>{booking.member}</span>}
                            <span className="channel" style={{ "--channel": channel.color }}><i />{channel.text}</span>
                        </div>
                    </div>

                    <div className="user-booking-price">{money(booking.price)}</div>

                </div>

            </div>
        )
    }

    _actions = () => {

        /* Fields */
        const { data } = this.state
        const { onEdit } = this.props

        return (
            <div className="review-actions">
                <div onClick={() => onEdit(data.review)} className="review-actions-button">
                    <Icon name="edit" size={15} width={2} />
                    Изменить отзыв
                </div>
                <div onClick={this.remove} className="user-block-link">
                    <Icon name="trash" size={15} width={2} />
                    Удалить
                </div>
            </div>
        )
    }

    /* The photo over the whole card, the arrows walk through the photos */
    _photo = () => {

        /* Fields */
        const { data, photo } = this.state

        if (!data || photo < 0 || !data.images[photo]) {
            return null
        }

        const total = data.images.length
        const walk = (event, step) => {
            event.stopPropagation()
            this.setState({ photo: (photo + step + total) % total })
        }

        return (
            <div onClick={() => this.setState({ photo: -1 })} className="review-lightbox">
                <img onClick={event => event.stopPropagation()} src={photoOf(data.images[photo].image)} alt="Фото отзыва" />
                {total > 1 &&
                    <>
                        <div onClick={event => walk(event, -1)} className="review-lightbox-arrow left"><Icon name="left" size={20} width={2.4} /></div>
                        <div onClick={event => walk(event, 1)} className="review-lightbox-arrow right"><Icon name="right" size={20} width={2.4} /></div>
                    </>
                }
                <div className="review-lightbox-count">{photo + 1} / {total}</div>
                <a onClick={event => event.stopPropagation()} href={photoOf(data.images[photo].image)} target="_blank" rel="noreferrer" className="review-lightbox-open">Открыть оригинал</a>
            </div>
        )
    }

    _body = () => {

        /* Fields */
        const { status } = this.state

        if (status === "loading") {
            return <div className="wide-modal-loading"><LoadingOutlined /></div>
        }

        if (status === "missing") {
            return (
                <div className="wide-modal-loading">
                    <Icon name="trash" size={38} width={1.5} />
                    <p>Отзыв уже удалён</p>
                </div>
            )
        }

        if (status !== "ok") {
            return (
                <div className="wide-modal-loading">
                    <Icon name="alert" size={38} width={1.5} />
                    <p>Не удалось загрузить отзыв</p>
                </div>
            )
        }

        return (
            <>
                {this._complaints()}
                {this._text()}
                {this._reply()}
                {this._booking()}
                {this._context()}
                {this._actions()}
            </>
        )
    }

    render = () => {

        /* Fields */
        const { visible, item } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="wide-modal large review-modal"
                overlayClassName="wide-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="wide-modal-header">
                    <h2>Отзыв</h2>
                    <div onClick={this.close} className="wide-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                {item &&
                    <div className="wide-modal-body">
                        {this._hero()}
                        {this._body()}
                    </div>
                }

                {this._photo()}

            </Modal>
        )
    }
}

export default ReviewModal
